export default {"src":"/_next/static/media/apple_auth.1ac00c74.svg","height":17,"width":15,"blurWidth":0,"blurHeight":0};